import { render, staticRenderFns } from "./modalEditBusinessNews.vue?vue&type=template&id=5eb3170c&"
import script from "./modalEditBusinessNews.vue?vue&type=script&lang=js&"
export * from "./modalEditBusinessNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports